// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"f14954cf","677":"55997b08","970":"a9d77acc"}[chunkId] + ".chunk.js";
};